module.exports = __webpack_public_path__ + "static/smoke-4ad60c31a3c1ab2c36efdc03096d8c54.png";